export default function ProductDetailController(
  $q,
  $scope,
  $stateParams,
  productService,
  packagesService,
  $uibModal,
  gettextCatalog,
) {
  'ngInject';
  $scope.loading = true;
  //bool for showing modules dropdown if modules exist for currently selected package
  $scope.hasPackageModules = false;
  // ceate an array to hold the modules selected in the dropdown list
  $scope.selectedModules = [];
  //container to hold the modules from the selected package in the dropdown
  $scope.selectedPackageModules = [];
  //cup other containers to hold base packages and modules
  $scope.packages = []; //holds any package containing a tag ('base')
  $scope.modules = []; //holds any package containing a tag ('module')
  //build out the product model
  $scope.product = {};
  $scope.selectedPackage = {};
  $scope.templateNames = {};

  // add or update a product
  $scope.submitproductForm = function () {
    if ($scope.productForm.$invalid || $scope.loading) {
      return;
    }
    $scope.errorFlag = false;
    $scope.product.modules = [];

    //multiselect does not return the entire module object, so we use the selected module.ids and compare them to all the modules
    if ($scope.selectedModules.length > 0 && $scope.modules.length > 0) {
      for (var i = 0; i < $scope.modules.length; i++) {
        for (var j = 0; j < $scope.selectedModules.length; j++) {
          if ($scope.selectedModules[j].id === $scope.modules[i].id) {
            $scope.product.modules.push($scope.modules[i]);
          } //inner if .
        } //inner for
      } //outer for
    } //out if
    else {
      $scope.hasPackageModules = false;
    }

    $scope.loading = true;
    productService
      .updateProduct($scope.product)
      .then(function (response) {
        $scope.product = response.data;
        $scope.isEditing = false;
        $scope.loading = false;
      })
      .catch(function (error) {
        handleError(error, 'An error occurred while updating the template.');
      });
  }; // end submitproductForm

  //Edit/Cancel Button
  $scope.editButtonClicked = function (editing) {
    if (editing === true) {
      //Edit Button clicked, so store a copy of the data model
      $scope.backup = angular.copy($scope.product);
      $scope.selectedModBackup = angular.copy($scope.selectedModules);
      $scope.selectedPackageModBackup = angular.copy($scope.selectedPackageModules);
    } else {
      //Cancelled, so copy data back
      $scope.product = $scope.backup;
      $scope.selectedModules = $scope.selectedModBackup;
      $scope.selectedPackageModules = $scope.selectedPackageModBackup;
    }
  };

  $scope.deleteProductPressed = function () {
    var modalInstance = $uibModal.open({
      animation: true,
      template: require('./_delete.confirmation.modal.html'),
      controller: 'ProductDeleteModalController',
      backdropClass: 'tr-template-delete-dismiss',
      resolve: {
        product: function () {
          return $scope.product;
        },
      },
      size: 'md',
    });
  };

  var getProduct = function (id) {
    id = id || $stateParams.id; // default to $stateParams.id if we don't have a value passed in
    $scope.isEditing = false;
    return productService
      .getProductById(id)
      .then(processProductResponse)
      .catch(function (error) {
        handleError(error, 'An error occurred while retrieving product information.');
      });
  };

  var processProductResponse = function (response) {
    $scope.product = response.data;

    $scope.selectedModules = [];
    $scope.selectedPackageModules = [];
    $scope.selectedPackageModulesIds = [];
    $scope.$emit('$viewContentLoaded'); // breadcrumbs notification

    if ($scope.product.package) {
      $scope.selectedPackage = $scope.product.package;
      for (let i = 0; i < $scope.packages.length; i++) {
        if ($scope.product.package.id === $scope.packages[i].id) {
          $scope.selectedPackageModulesIds.push($scope.packages[i].modules);
        } //inner if
      } //outer for
    } //out if

    for (let i = 0; i < $scope.modules.length; i++) {
      for (let j = 0; j < $scope.selectedPackageModulesIds[0].length; j++) {
        if ($scope.selectedPackageModulesIds[0][j] === $scope.modules[i].id) {
          $scope.selectedPackageModules.push($scope.modules[i]);
        } //inner if .
      } //inner for
    } //outer for

    if ($scope.product.modules.length > 0 && $scope.modules.length > 0) {
      $scope.hasPackageModules = true;
      for (let i = 0; i < $scope.modules.length; i++) {
        for (let j = 0; j < $scope.product.modules.length; j++) {
          if ($scope.product.modules[j].id === $scope.modules[i].id) {
            $scope.selectedModules.push($scope.modules[i]);
          } //inner if .
        } //inner for
      } //outer for
    } //out if
    else {
      $scope.hasPackageModules = false;
      $scope.selectedModules = [];
    }

    $scope.loading = false;
  };

  /**
   * Handle an error in a remote call
   * @param {any} error
   * @param {string} message
   */
  var handleError = function (error, message) {
    $scope.product = {};
    var errorMsg = gettextCatalog.getString(message);

    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }

    $scope.onLoadErrorFlag = true;
    $scope.onLoadErrorText = errorMsg;
    $scope.loading = false;

    return $q.reject();
  };

  var getTemplateNames = function () {
    productService
      .getAllProductsNames()
      .then(function (names) {
        $scope.templateNames = names;
      })
      .catch(() => {});
  };

  var getPackages = function () {
    return packagesService
      .getAllPackages()
      .then((response) => {
        processPackagesResponse(response);
        getProduct($stateParams.id);
      })
      .catch(function (error) {
        handleError(error, 'An error occurred while retrieving package information.');
      });
  };

  var processPackagesResponse = function (response) {
    //Resolve the packages
    $scope.packages = [];
    $scope.modules = [];

    for (var i = 0; i < response.data.length; i++) {
      var _package = response.data[i];
      if (!_package.inactive) {
        if (_package.tags) {
          if (_package.isModule) {
            $scope.modules.push(_package);
            continue;
          }
        }

        $scope.packages.push(_package);
      }
    }
  };
  getTemplateNames();
  getPackages();

  $scope.changeSelectedPackage = function (selectedPackage) {
    $scope.product.package = selectedPackage;
    $scope.selectedItemChanged();
    window.dataLayer.push({
      event: 'templatePackageChanged',
    });
  };

  $scope.addModuleToProduct = function (module) {
    $scope.selectedModules.push(module);
    ModuleChanged('templateAddModuleChanged');
  };

  $scope.removeModuleFromProduct = function (module) {
    var idx = $scope.selectedModules.indexOf(module);
    $scope.selectedModules.splice(idx, 1);
    ModuleChanged('templateRemoveModuleChanged');
  };

  function ModuleChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.selectedModules.length,
      },
    });
  }

  //selectedItemChanged() will traverse the modules[] and the packages.modules[], compare the modules list in
  //both result sets and determine wether or not the selectedPackage has compatible modules to display to the user.
  $scope.selectedItemChanged = function () {
    $scope.selectedPackageModules = [];
    $scope.selectedModules = [];
    if ($scope.product.package.modules && $scope.product.package.modules.length >= 1) {
      angular.forEach($scope.modules, function (gm) {
        angular.forEach($scope.product.package.modules, function (pm) {
          if (gm.id === pm) {
            $scope.selectedPackageModules.push(gm);
          }
        });
      });
    }
    //set hide or show the modules dropdown
    if ($scope.selectedPackageModules.length > 0) {
      $scope.hasPackageModules = true;
    } else {
      //We need to remove the existing values from the model and selectedPackageModules when hasModules is false.
      $scope.hasPackageModules = false;
      $scope.selectedModules = [];
      $scope.selectedPackageModules = [];
    }
  };

  $scope.nameChanged = function () {
    let template = $scope.templateNames[$scope.product.name.toLowerCase()];
    $scope.productForm.prodname.exists = !!template && template.id !== $scope.product.id;
    window.dataLayer.push({
      event: 'templateNameChanged',
    });
  };

  $scope.makeChanged = function () {
    window.dataLayer.push({
      event: 'templateMakeChanged',
    });
  };

  $scope.modelChanged = function () {
    window.dataLayer.push({
      event: 'templateModelChanged',
    });
  };
}
